export default "__VITE_ASSET__BdsOS7QH__"